import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { SessionService } from '../session/session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _http = inject(HttpClient);
  private _router = inject(Router);
  private _session = inject(SessionService);

  public user = signal<any | null>(null);

  constructor() {
    this.user.set(this._session.getSession());
  }

  getToken(): string | null {
    try {
      const session = this._session.getSession();
      return session?.token || null;
    } catch (error) {
      return null;
    }
  }

  verifyToken(token: string): Promise<boolean> {
    try {
      this._http.get<any>(`${environment.apiUrl}/administrative/authentication/profile/`, { headers: { Authorization: `Bearer ${token}` } })
        .subscribe((data: any) => {
          const session = this._session.getSession();

          if (session) {
            this.user.set(session);
          }
        });

      return Promise.resolve(true);
    } catch (error) {
      return Promise.resolve(false);
    }
  }

  async login(email: string, password: string): Promise<boolean> {
    const loginObservable = this._http.post<any>(
      `${environment.apiUrl}/administrative/authentication/login/`,
      {
        username: email,
        password,
      }
    );

    try {
      const data = await firstValueFrom(loginObservable);

      const session = {
        token: data.data.access_token,
        user: data.data.user,
        employee: data.data.employee,
        company: data.data.company,
      };

      this._session.setSession(session);
      this.user.set(session);

      this._router.navigate(['/']);
      return true;
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      return false;
    }
  }

  logout(): Promise<boolean> {
    try {
      this._session.clearSession();
      this.user.set(null);
      this._router.navigate(['/login']);

      return Promise.resolve(true);
    } catch (error) {
      return Promise.resolve(false);
    }
  }

  get activeUser(): any | null {
    return this.user();
  }
}
